import { render, staticRenderFns } from "./WorkerNegotiationsTab.htm?vue&type=template&id=180d9d28&"
import script from "./WorkerNegotiationsTab.ts?vue&type=script&lang=js&"
export * from "./WorkerNegotiationsTab.ts?vue&type=script&lang=js&"
import style0 from "../MyJobsTab.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports